module.exports = __webpack_public_path__ + "img/logo-3.005e328b.png";